export const SERVICE_CODE = 'TRAINING_OBJECTIVE' + '_SERVICE';
